import {SET_CIRKLON_PARAMETER_SELECTED} from 'constants/action-types.js';
import {SET_CIRKLON_MODE} from 'constants/action-types.js';
import {HIDE_ALL_EFFECTS} from 'constants/action-types.js';

let initialState = {
    cirklonParameterSelected: {},
    cirklonMode: {},
};

const stepsReducer= (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case HIDE_ALL_EFFECTS:
        return {
            ... state,
            cirklonParameterSelected: {}
        };
    case SET_CIRKLON_PARAMETER_SELECTED:
        let cirklonParameterSelected = {... state.cirklonParameterSelected};
        cirklonParameterSelected[action.payload.track] =
            action.payload.parameter;
        return {
            ... state,
            cirklonParameterSelected
        };
    case SET_CIRKLON_MODE:
        let cirklonMode = {... state.cirklonMode};
        cirklonMode[action.payload.track] =
            action.payload.mode;
        return {
            ... state,
            cirklonMode
        };
   default:
        return state;
    }
};

export default stepsReducer;
